/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { MessageDto } from '../models/message-dto';
import { messageGet$Json } from '../fn/message/message-get-json';
import { MessageGet$Json$Params } from '../fn/message/message-get-json';
import { messageGet$Plain } from '../fn/message/message-get-plain';
import { MessageGet$Plain$Params } from '../fn/message/message-get-plain';

@Injectable({ providedIn: 'root' })
export class MessageService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `messageGet()` */
  static readonly MessageGetPath = '/v1/Message/Get';

  /**
   * Search messages,   Permissions [AuthenticatedUser|LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME|INSURER].
   *
   * It will return all matching messages on your filter criteria
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messageGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  messageGet$Plain$Response(params?: MessageGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MessageDto>>> {
    return messageGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Search messages,   Permissions [AuthenticatedUser|LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME|INSURER].
   *
   * It will return all matching messages on your filter criteria
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messageGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  messageGet$Plain(params?: MessageGet$Plain$Params, context?: HttpContext): Observable<Array<MessageDto>> {
    return this.messageGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MessageDto>>): Array<MessageDto> => r.body)
    );
  }

  /**
   * Search messages,   Permissions [AuthenticatedUser|LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME|INSURER].
   *
   * It will return all matching messages on your filter criteria
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messageGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  messageGet$Json$Response(params?: MessageGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MessageDto>>> {
    return messageGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search messages,   Permissions [AuthenticatedUser|LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME|INSURER].
   *
   * It will return all matching messages on your filter criteria
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messageGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  messageGet$Json(params?: MessageGet$Json$Params, context?: HttpContext): Observable<Array<MessageDto>> {
    return this.messageGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MessageDto>>): Array<MessageDto> => r.body)
    );
  }

}
